const BurgerMenuIcon = () => {
  return (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="22" y1="1.8335" x2="-8.74228e-08" y2="1.83349" stroke="#444D4E" strokeWidth="2"/>
      <line x1="22" y1="10.8335" x2="-8.74228e-08" y2="10.8335" stroke="#444D4E" strokeWidth="2"/>
      <line x1="22" y1="19.8335" x2="-8.74228e-08" y2="19.8335" stroke="#444D4E" strokeWidth="2"/>
    </svg>
  )
}

export default BurgerMenuIcon